import { createUseStyles } from "react-jss";
import { LIGHT_GRAY } from "../../../constants/colors";
import { FONT_FAMILY, SPACING } from "../../../constants/styleGuide";

const AFADetailsStyles = createUseStyles({
    container: {
        background: LIGHT_GRAY,
        padding: "24px 32px",
        minHeight: "100vh",
    },
    breadcrumbContainer: {
        marginBottom: SPACING.s16,
    },
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: SPACING.s24,
        background: "#ffffff",
        padding: SPACING.s24,
        borderRadius: "4px",
        paddingBottom: "35px"
    },
    titleSection: {
        display: "flex",
        alignItems: "center",
        gap: SPACING.s16,
    },
    title: {
        fontSize: "36px",
        fontWeight: "bold",
        fontFamily: FONT_FAMILY.BOGLE,
        color: "#2E2F32",
        margin: 0,
        position: 'relative'
    },
    subTitle: {
        display: "block",
        fontSize: "14px",
        color: "#3e3e3e",
        fontWeight: "normal",
        position: "absolute",
        bottom: "-22px",
        left: "3px",
        width: "200%"
    },
    statusChip: {
        backgroundColor: "#e8f5e8",
        color: "#2d5016",
        fontWeight: "bold",
        fontSize: "12px",
        padding: "4px 12px",
        borderRadius: "16px",
        border: "1px solid #2d5016",
    },
    actionButtons: {
        display: "flex",
        gap: SPACING.s8,
    },
    infoCard: {
        background: "#ffffff",
        marginRight: SPACING.s24,
        borderRadius: "4px",
        padding: SPACING.s24,
    },
    infoCardRight: {
        background: "#ffffff",
        borderRadius: "4px",
        padding: SPACING.s24,
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: SPACING.s24,
        marginBottom: SPACING.s32,
    },
    infoItem: {
        display: "flex",
        flexDirection: "column",
    },
    infoLabel: {
        fontSize: "13px",
        color: "#3e3e3e",
        marginBottom: SPACING.s4,
        fontFamily: FONT_FAMILY.BOGLE,
        textTransform: "capitalize",
    },
    infoValue: {
        fontSize: "22px",
        fontWeight: "600",
        color: "#2E2F32",
        fontFamily: FONT_FAMILY.BOGLE,
    },
    infoValueCapitalize: {
        fontSize: "22px",
        fontWeight: "600",
        color: "#2E2F32",
        fontFamily: FONT_FAMILY.BOGLE,
        textTransform: "capitalize"
    },
    sectionTitle: {
        fontSize: "20px",
        fontWeight: "bold",
        color: "#2E2F32",
        marginBottom: SPACING.s16,
        fontFamily: FONT_FAMILY.BOGLE,
        display: "flex",
        gap: 10,
        alignItems: "center"
    },
    phaseTable: {
        "& .MuiTableHead-root": {
            backgroundColor: "#f8f9fa",
        },
        "& .MuiTableCell-head": {
            fontWeight: "bold",
            fontSize: "12px",
            color: "#2E2F32",
            fontFamily: FONT_FAMILY.BOGLE,
            textTransform: "uppercase",
            borderBottom: "1px solid #dee2e6",
        },
        "& .MuiTableCell-body": {
            fontSize: "14px",
            fontFamily: FONT_FAMILY.BOGLE,
            borderBottom: "1px solid #f1f3f4",
        },
        "& .MuiTableRow-root:hover": {
            backgroundColor: "#f8f9fa",
        },
    },
    metadataGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: SPACING.s16,
    },
    metadataItem: {
        display: "flex",
        justifyContent: "space-between",
        padding: `${SPACING.s8}px 0`,
        borderBottom: "1px solid #f1f3f4",
        gap: 15,
        "&:last-child": {
            borderBottom: "none",
        },
    },
    metadataLabel: {
        fontSize: "14px",
        color: "#3e3e3e",
        fontFamily: FONT_FAMILY.BOGLE,
    },
    metadataValue: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#2E2F32",
        fontFamily: FONT_FAMILY.BOGLE,
        textAlign: "right"
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        fontSize: "16px",
        color: "#666",
    },
    notFoundContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        fontSize: "16px",
        color: "#666",
    },
    spinnerIcon: {
        height: '20px',
        width: '20px'
    }
});

export default AFADetailsStyles;
